import { render, staticRenderFns } from "./PermissionNotice.vue?vue&type=template&id=61e899f2"
import script from "./PermissionNotice.vue?vue&type=script&lang=js"
export * from "./PermissionNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports